import { useState, useEffect } from 'react';

/**
 * Hook debounce cho bất kỳ giá trị nào
 * @param value Giá trị muốn debounce
 * @param milliSeconds Thời gian debounce (ms)
 */
export function useDebounce<T>(value: T, milliSeconds: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, milliSeconds);

    return () => {
      clearTimeout(handler);
    };
  }, [value, milliSeconds]);

  return debouncedValue;
}
